import React, { ReactNode } from 'react';
export const CardTemplate = (_props: { children: ReactNode[] | ReactNode }): JSX.Element => <></>;
